/* Journal: story filters and "Load more". */
(() => {
'use strict';
const mount = (window.BotanifolSite && window.BotanifolSite.mount) || (fn => fn());
mount(() => {
const grid = document.getElementById('journal-grid'), textNode = document.getElementById('journal-text');
if (!grid || !textNode) return;
const T = JSON.parse(textNode.textContent);
const cards = [...grid.children], buttons = [...document.querySelectorAll('[data-filter]')], more = document.getElementById('load-stories');
let category = 'All stories', limit = 12;
function matches() { return cards.filter(c => category === 'All stories' || c.dataset.category === category); }
function render() {
  const list = matches();
  cards.forEach(c => { c.hidden = !list.slice(0, limit).includes(c); });
  const shown = Math.min(limit, list.length);
  document.getElementById('story-count').textContent = T.count.replace('[shown]', shown).replace('[total]', list.length);
  more.hidden = shown === list.length;
  document.getElementById('load-caption').textContent = shown === list.length ? T.done : T.more.replace('[count]', list.length - shown);
  buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.filter === category)));
}
buttons.forEach(b => b.addEventListener('click', () => { category = b.dataset.filter; limit = 12; render(); }));
more.addEventListener('click', () => {
  const next = matches()[limit]; limit += 6; render();
  if (next) next.querySelector('a')?.focus({ preventScroll: true });
});
render();
});
})();
